import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayersTwo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layers-two, stack"} maskId="square-filled-radius-0-stroke-1-IconLayersTwo"><path d="M6.28244 12.5001L1.47656 15.1876L12.001 21.073L22.5254 15.1876L17.7195 12.5001L12.001 15.698L6.28244 12.5001Z" fill="currentColor"/><path d="M12.001 2.92725L1.47656 8.81262L12.001 14.698L22.5254 8.81262L12.001 2.92725Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayersTwo;
